import { Subject } from "rxjs";
class Cursor {
    constructor(host, offset = 0, prefer = "left") {
        this.onChange = new Subject();
        this.host = host;
        this.offsetField = offset;
        this.prefer = prefer;
        this.host.trackedCursors.add(this);
        this.live = true;
    }
    get __brand() {
        return "d9bb8a8a-cf02-4a91-b141-0d04e0ed67e9";
    }
    get offset() {
        return this.offsetField;
    }
    set offset(offset) {
        if (offset !== this.offsetField) {
            this.offsetField = offset;
            this.onChange.next();
        }
    }
    release() {
        this.host.trackedCursors.delete(this);
        this.live = false;
    }
}
export default Cursor;
